function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  position: relative;\n  padding: 0;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import styled from "styled-components";
import { connect as connectFormik, getIn } from "formik";
import Label from "../label";
import { ItalicText, MutedText } from "../text";
import InputError from "../input-error";
import { context } from "../wr-context";
import propTypes from "prop-types";
import memoize from "memoize-one";
import { Editor } from "@tinymce/tinymce-react";
var EditorWrapper = styled.div(_templateObject(), function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth && " width: 100%;";
});
var StyledLabel = styled.label(_templateObject1(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.form) === null || ref === void 0 ? void 0 : ref.width;
});
var EditorContainer = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(EditorContainer, Component);
    var _super = _createSuper(EditorContainer);
    function EditorContainer() {
        _classCallCheck(this, EditorContainer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loaded: false
        };
        _this.config = memoize(function(height, config) {
            return _objectSpread({}, context.constants.editor.config, height && {
                height: height
            }, config || {});
        });
        _this.handleLoaded = function() {
            if (window.tinyMCE) {
                _this.setState({
                    loaded: true
                });
            }
        };
        _this.isControlled = "value" in _this.props;
        _this.onChange = function(value) {
            var _props = _this.props, onChange = _props.onChange, name = _props.name, tag = _props.tag;
            if (_this.isControlled && onChange) {
                onChange({
                    target: {
                        value: {
                            tag: tag,
                            value: value
                        },
                        name: name
                    }
                });
            } else {
                _this.setState({
                    editor: value
                });
            }
        };
        return _this;
    }
    var _proto = EditorContainer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var assetHost = context.constants.editor.assetHost;
        var tinyMceScript = document.getElementById("tinymce");
        if (typeof window.tinyMCE === "undefined") {
            if (!tinyMceScript) {
                var script = document.createElement("script");
                script.src = "".concat(assetHost, "tinymce.min.js");
                script.id = "tinymce";
                document.body.appendChild(script);
                tinyMceScript = script;
            }
            tinyMceScript.addEventListener("load", this.handleLoaded);
        } else {
            this.setState({
                loaded: true
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var tinyMceScript = document.getElementById("tinymce");
        tinyMceScript === null || tinyMceScript === void 0 ? void 0 : tinyMceScript.removeEventListener("load", this.handleLoaded);
    };
    _proto.render = function render() {
        var _props = this.props, _label = _props.label, label = _label === void 0 ? "" : _label, fullWidth = _props.fullWidth, _className = _props.className, className = _className === void 0 ? "" : _className, propsValue = _props.value, disabled = _props.disabled, error = _props.error, hintText = _props.hintText, height = _props.height;
        var config = this.config(height, this.props.config);
        var apiKey = context.constants.editor.apiKey;
        var value = this.isControlled ? propsValue : this.state.value;
        var onChange = this.onChange;
        var hintTextNode = hintText && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MutedText, null, /*#__PURE__*/ React.createElement(ItalicText, null, hintText)));
        return /*#__PURE__*/ React.createElement(EditorWrapper, {
            fullWidth: fullWidth,
            className: className
        }, /*#__PURE__*/ React.createElement(StyledLabel, {
            fullWidth: fullWidth
        }, label && /*#__PURE__*/ React.createElement(Label, null, label), hintTextNode, this.state.loaded && /*#__PURE__*/ React.createElement(Editor, {
            apiKey: apiKey,
            init: config,
            value: value,
            disabled: disabled,
            onEditorChange: onChange
        })), !!error && /*#__PURE__*/ React.createElement(InputError, null, typeof error === "string" ? error : error.value));
    };
    return EditorContainer;
}(Component);
EditorContainer.propTypes = {
    onChange: propTypes.func,
    name: propTypes.string,
    tag: propTypes.string,
    label: propTypes.string,
    fullWidth: propTypes.bool,
    className: propTypes.string,
    value: propTypes.string,
    disabled: propTypes.bool,
    error: propTypes.string,
    hintText: propTypes.node,
    height: propTypes.string,
    config: propTypes.object
};
var FormikEditor = connectFormik(function(_param) {
    var formik = _param.formik, rest = _objectWithoutProperties(_param, [
        "formik"
    ]);
    var value = getIn(formik.values, rest.name);
    var touched = getIn(formik.touched, rest.name);
    var error = touched ? getIn(formik.errors, rest.name) : null;
    return /*#__PURE__*/ React.createElement(EditorContainer, _extends({
        error: error,
        value: value,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur
    }, rest));
});
export { FormikEditor };
export default EditorContainer;
